import api from "../lib/apiClient";
export const listJournal = () => api.get("/journal").then((r) => r.data.entries);
export const addJournal = (payload) => api.post("/journal", payload).then((r) => r.data);
export const editJournal = (id, payload) => api.patch(`/journal/${id}`, payload).then((r) => r.data);
export const deleteJournal = (id) => api.delete(`/journal/${id}`).then((r) => r.data);
